import { useMemo } from 'react'
import { Rate, Rates } from 'src/subscribe'
import SubscriptionRate from './SubscriptionRate'

const SubscriptionRates = ({
  rates,
  rates_banner,
  rates_subtitle,
}: {
  rates: Rates
  rates_banner: string | null
  rates_subtitle: string | null
}) => {
  const orderedRates: Rate[] = useMemo(() => {
    const ors: Rate[] = Object.entries(rates).map(([nid, r]) => ({
      ...r,
      nid,
    }))
    ors.sort((a, b) => {
      if (parseInt(a.price_in_cents, 10) < parseInt(b.price_in_cents, 10)) {
        return -1
      }
      if (parseInt(a.price_in_cents, 10) > parseInt(b.price_in_cents, 10)) {
        return 1
      }
      return 0
    })
    return ors
  }, [])

  return (
    <div className="page page1 show">
      <div>
        <fieldset id="edit-subscription-rates">
          <legend>
            <span>Subscription rates</span>
          </legend>
        </fieldset>
      </div>
      <div
        className="field--name-field-rates-subtitle"
        dangerouslySetInnerHTML={{ __html: rates_subtitle || '' }}
      />
      <div id="edit-tiles">
        <div>
          <div className="view-content">
            {orderedRates.map((r) => (
              <SubscriptionRate key={r.nid} rate={r} />
            ))}
          </div>
        </div>
      </div>
      <div
        className="field field--name-field-rates-banner field--type-text-long field--label-hidden field__item"
        dangerouslySetInnerHTML={{ __html: rates_banner || '' }}
      />
    </div>
  )
}

export default SubscriptionRates
